import { useState, useEffect, useCallback } from 'react';
import { assessmentProgressApi } from '../services/api';

interface FormulationProgress {
  summary: number;
  strategies: number;
  overall: number;
}

export function useFormulationProgress(companyId: string) {
  const [progress, setProgress] = useState<FormulationProgress>({
    summary: 0,
    strategies: 0,
    overall: 0,
  });

  const [isLoading, setIsLoading] = useState(false);

  // Function to refresh progress
  const refreshProgress = useCallback(async () => {
    if (!companyId) return;

    setIsLoading(true);
    try {
      const response = await assessmentProgressApi.getFormulationProgress(companyId);

      if (response.success && response.data) {
        setProgress({
          summary: response.data.sections.summary,
          strategies: response.data.sections.strategies,
          overall: response.data.overall,
        });
      } else {
        console.error('Formulation progress API call failed:', response.error);
      }
    } catch (error) {
      console.error('Failed to calculate formulation progress:', error);
    } finally {
      setIsLoading(false);
    }
  }, [companyId]);

  // Load progress on mount and when companyId changes
  useEffect(() => {
    if (companyId) {
      refreshProgress();
    }
  }, [companyId]);

  return {
    progress,
    isLoading,
    refreshProgress,
  };
}
